/* eslint-disable */
import Long from 'long';
import * as _m0 from 'protobufjs/minimal';

export const protobufPackage = 'od_protos.journey.data';

/** Next ID: 11 */
export interface WebsiteSource {
  url: string;
  userAgent?: string;
  ip?: string;
  referrer?: string;
  /** pathname if we show/proxy a different page than requested based on context */
  proxyPath?: string;
  /** request.url.pathname */
  pathname?: string;
  /** request.url.search ({ 'x': '5', 'y': '3', 'z': 'a,b' }) */
  queryMap: { [key: string]: string };
  /** request.url.host */
  host?: string;
  /** where the event is coming from (mostly useful for debugging page view events) */
  eventOrigin: WebsiteSource_EventOrigin;
}

export enum WebsiteSource_EventOrigin {
  UNSPECIFIED = 0,
  SERVER = 1,
  CLIENT = 2,
  UNRECOGNIZED = -1,
}

export function websiteSource_EventOriginFromJSON(object: any): WebsiteSource_EventOrigin {
  switch (object) {
    case 0:
    case 'UNSPECIFIED':
      return WebsiteSource_EventOrigin.UNSPECIFIED;
    case 1:
    case 'SERVER':
      return WebsiteSource_EventOrigin.SERVER;
    case 2:
    case 'CLIENT':
      return WebsiteSource_EventOrigin.CLIENT;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return WebsiteSource_EventOrigin.UNRECOGNIZED;
  }
}

export function websiteSource_EventOriginToJSON(object: WebsiteSource_EventOrigin): string {
  switch (object) {
    case WebsiteSource_EventOrigin.UNSPECIFIED:
      return 'UNSPECIFIED';
    case WebsiteSource_EventOrigin.SERVER:
      return 'SERVER';
    case WebsiteSource_EventOrigin.CLIENT:
      return 'CLIENT';
    default:
      return 'UNKNOWN';
  }
}

export interface WebsiteSource_QueryMapEntry {
  key: string;
  value: string;
}

/** Next ID: 22 */
export interface MobileSource {
  userAgent?: string;
  ip?: string;
  /** App info */
  appName: string;
  appBuild?: string;
  appVersion?: string;
  appNamespace?: string;
  /** Device info */
  deviceId: string;
  deviceType?: string;
  deviceModel?: string;
  deviceManufacturer?: string;
  deviceName?: string;
  advertisingId?: string;
  adTrackingEnabled?: boolean;
  notificationPermissionStatus?: string;
  /** Network info */
  carrier?: string;
  /** OS info */
  osName?: string;
  osVersion?: string;
  /** Screen info */
  screenDensity?: number;
  /** In pixels */
  screenHeight?: number;
  /** In pixels */
  screenWidth?: number;
  /** Route info */
  focusRouteName: string;
}

/** Next ID: 2 */
export interface BackendSource {
  name: string;
}

/** Next ID: 2 */
export interface SmsSource {
  name: string;
}

function createBaseWebsiteSource(): WebsiteSource {
  return {
    url: '',
    userAgent: undefined,
    ip: undefined,
    referrer: undefined,
    proxyPath: undefined,
    pathname: undefined,
    queryMap: {},
    host: undefined,
    eventOrigin: 0,
  };
}

export const WebsiteSource = {
  fromJSON(object: any): WebsiteSource {
    return {
      url: isSet(object.url) ? String(object.url) : '',
      userAgent: isSet(object.userAgent) ? String(object.userAgent) : undefined,
      ip: isSet(object.ip) ? String(object.ip) : undefined,
      referrer: isSet(object.referrer) ? String(object.referrer) : undefined,
      proxyPath: isSet(object.proxyPath) ? String(object.proxyPath) : undefined,
      pathname: isSet(object.pathname) ? String(object.pathname) : undefined,
      queryMap: isObject(object.queryMap)
        ? Object.entries(object.queryMap).reduce<{ [key: string]: string }>((acc, [key, value]) => {
            acc[key] = String(value);
            return acc;
          }, {})
        : {},
      host: isSet(object.host) ? String(object.host) : undefined,
      eventOrigin: isSet(object.eventOrigin)
        ? websiteSource_EventOriginFromJSON(object.eventOrigin)
        : 0,
    };
  },

  toJSON(message: WebsiteSource): unknown {
    const obj: any = {};
    message.url !== undefined && (obj.url = message.url);
    message.userAgent !== undefined && (obj.userAgent = message.userAgent);
    message.ip !== undefined && (obj.ip = message.ip);
    message.referrer !== undefined && (obj.referrer = message.referrer);
    message.proxyPath !== undefined && (obj.proxyPath = message.proxyPath);
    message.pathname !== undefined && (obj.pathname = message.pathname);
    obj.queryMap = {};
    if (message.queryMap) {
      Object.entries(message.queryMap).forEach(([k, v]) => {
        obj.queryMap[k] = v;
      });
    }
    message.host !== undefined && (obj.host = message.host);
    message.eventOrigin !== undefined &&
      (obj.eventOrigin = websiteSource_EventOriginToJSON(message.eventOrigin));
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<WebsiteSource>, I>>(object: I): WebsiteSource {
    const message = createBaseWebsiteSource();
    message.url = object.url ?? '';
    message.userAgent = object.userAgent ?? undefined;
    message.ip = object.ip ?? undefined;
    message.referrer = object.referrer ?? undefined;
    message.proxyPath = object.proxyPath ?? undefined;
    message.pathname = object.pathname ?? undefined;
    message.queryMap = Object.entries(object.queryMap ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = String(value);
        }
        return acc;
      },
      {},
    );
    message.host = object.host ?? undefined;
    message.eventOrigin = object.eventOrigin ?? 0;
    return message;
  },
};

function createBaseWebsiteSource_QueryMapEntry(): WebsiteSource_QueryMapEntry {
  return { key: '', value: '' };
}

export const WebsiteSource_QueryMapEntry = {
  fromJSON(object: any): WebsiteSource_QueryMapEntry {
    return {
      key: isSet(object.key) ? String(object.key) : '',
      value: isSet(object.value) ? String(object.value) : '',
    };
  },

  toJSON(message: WebsiteSource_QueryMapEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<WebsiteSource_QueryMapEntry>, I>>(
    object: I,
  ): WebsiteSource_QueryMapEntry {
    const message = createBaseWebsiteSource_QueryMapEntry();
    message.key = object.key ?? '';
    message.value = object.value ?? '';
    return message;
  },
};

function createBaseMobileSource(): MobileSource {
  return {
    userAgent: undefined,
    ip: undefined,
    appName: '',
    appBuild: undefined,
    appVersion: undefined,
    appNamespace: undefined,
    deviceId: '',
    deviceType: undefined,
    deviceModel: undefined,
    deviceManufacturer: undefined,
    deviceName: undefined,
    advertisingId: undefined,
    adTrackingEnabled: undefined,
    notificationPermissionStatus: undefined,
    carrier: undefined,
    osName: undefined,
    osVersion: undefined,
    screenDensity: undefined,
    screenHeight: undefined,
    screenWidth: undefined,
    focusRouteName: '',
  };
}

export const MobileSource = {
  fromJSON(object: any): MobileSource {
    return {
      userAgent: isSet(object.userAgent) ? String(object.userAgent) : undefined,
      ip: isSet(object.ip) ? String(object.ip) : undefined,
      appName: isSet(object.appName) ? String(object.appName) : '',
      appBuild: isSet(object.appBuild) ? String(object.appBuild) : undefined,
      appVersion: isSet(object.appVersion) ? String(object.appVersion) : undefined,
      appNamespace: isSet(object.appNamespace) ? String(object.appNamespace) : undefined,
      deviceId: isSet(object.deviceId) ? String(object.deviceId) : '',
      deviceType: isSet(object.deviceType) ? String(object.deviceType) : undefined,
      deviceModel: isSet(object.deviceModel) ? String(object.deviceModel) : undefined,
      deviceManufacturer: isSet(object.deviceManufacturer)
        ? String(object.deviceManufacturer)
        : undefined,
      deviceName: isSet(object.deviceName) ? String(object.deviceName) : undefined,
      advertisingId: isSet(object.advertisingId) ? String(object.advertisingId) : undefined,
      adTrackingEnabled: isSet(object.adTrackingEnabled)
        ? Boolean(object.adTrackingEnabled)
        : undefined,
      notificationPermissionStatus: isSet(object.notificationPermissionStatus)
        ? String(object.notificationPermissionStatus)
        : undefined,
      carrier: isSet(object.carrier) ? String(object.carrier) : undefined,
      osName: isSet(object.osName) ? String(object.osName) : undefined,
      osVersion: isSet(object.osVersion) ? String(object.osVersion) : undefined,
      screenDensity: isSet(object.screenDensity) ? Number(object.screenDensity) : undefined,
      screenHeight: isSet(object.screenHeight) ? Number(object.screenHeight) : undefined,
      screenWidth: isSet(object.screenWidth) ? Number(object.screenWidth) : undefined,
      focusRouteName: isSet(object.focusRouteName) ? String(object.focusRouteName) : '',
    };
  },

  toJSON(message: MobileSource): unknown {
    const obj: any = {};
    message.userAgent !== undefined && (obj.userAgent = message.userAgent);
    message.ip !== undefined && (obj.ip = message.ip);
    message.appName !== undefined && (obj.appName = message.appName);
    message.appBuild !== undefined && (obj.appBuild = message.appBuild);
    message.appVersion !== undefined && (obj.appVersion = message.appVersion);
    message.appNamespace !== undefined && (obj.appNamespace = message.appNamespace);
    message.deviceId !== undefined && (obj.deviceId = message.deviceId);
    message.deviceType !== undefined && (obj.deviceType = message.deviceType);
    message.deviceModel !== undefined && (obj.deviceModel = message.deviceModel);
    message.deviceManufacturer !== undefined &&
      (obj.deviceManufacturer = message.deviceManufacturer);
    message.deviceName !== undefined && (obj.deviceName = message.deviceName);
    message.advertisingId !== undefined && (obj.advertisingId = message.advertisingId);
    message.adTrackingEnabled !== undefined && (obj.adTrackingEnabled = message.adTrackingEnabled);
    message.notificationPermissionStatus !== undefined &&
      (obj.notificationPermissionStatus = message.notificationPermissionStatus);
    message.carrier !== undefined && (obj.carrier = message.carrier);
    message.osName !== undefined && (obj.osName = message.osName);
    message.osVersion !== undefined && (obj.osVersion = message.osVersion);
    message.screenDensity !== undefined && (obj.screenDensity = message.screenDensity);
    message.screenHeight !== undefined && (obj.screenHeight = message.screenHeight);
    message.screenWidth !== undefined && (obj.screenWidth = message.screenWidth);
    message.focusRouteName !== undefined && (obj.focusRouteName = message.focusRouteName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MobileSource>, I>>(object: I): MobileSource {
    const message = createBaseMobileSource();
    message.userAgent = object.userAgent ?? undefined;
    message.ip = object.ip ?? undefined;
    message.appName = object.appName ?? '';
    message.appBuild = object.appBuild ?? undefined;
    message.appVersion = object.appVersion ?? undefined;
    message.appNamespace = object.appNamespace ?? undefined;
    message.deviceId = object.deviceId ?? '';
    message.deviceType = object.deviceType ?? undefined;
    message.deviceModel = object.deviceModel ?? undefined;
    message.deviceManufacturer = object.deviceManufacturer ?? undefined;
    message.deviceName = object.deviceName ?? undefined;
    message.advertisingId = object.advertisingId ?? undefined;
    message.adTrackingEnabled = object.adTrackingEnabled ?? undefined;
    message.notificationPermissionStatus = object.notificationPermissionStatus ?? undefined;
    message.carrier = object.carrier ?? undefined;
    message.osName = object.osName ?? undefined;
    message.osVersion = object.osVersion ?? undefined;
    message.screenDensity = object.screenDensity ?? undefined;
    message.screenHeight = object.screenHeight ?? undefined;
    message.screenWidth = object.screenWidth ?? undefined;
    message.focusRouteName = object.focusRouteName ?? '';
    return message;
  },
};

function createBaseBackendSource(): BackendSource {
  return { name: '' };
}

export const BackendSource = {
  fromJSON(object: any): BackendSource {
    return {
      name: isSet(object.name) ? String(object.name) : '',
    };
  },

  toJSON(message: BackendSource): unknown {
    const obj: any = {};
    message.name !== undefined && (obj.name = message.name);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<BackendSource>, I>>(object: I): BackendSource {
    const message = createBaseBackendSource();
    message.name = object.name ?? '';
    return message;
  },
};

function createBaseSmsSource(): SmsSource {
  return { name: '' };
}

export const SmsSource = {
  fromJSON(object: any): SmsSource {
    return {
      name: isSet(object.name) ? String(object.name) : '',
    };
  },

  toJSON(message: SmsSource): unknown {
    const obj: any = {};
    message.name !== undefined && (obj.name = message.name);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<SmsSource>, I>>(object: I): SmsSource {
    const message = createBaseSmsSource();
    message.name = object.name ?? '';
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string }
  ? { [K in keyof Omit<T, '$case'>]?: DeepPartial<T[K]> } & { $case: T['$case'] }
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<Exclude<keyof I, KeysOfUnion<P>>, never>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === 'object' && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
